import React from 'react'
import './Style.css'

const Color = props => {
  const classNames = ['Style', 'Style-Color']

  if(props.success) classNames.push('has-color-success')
  if(props.error) classNames.push('has-color-error')
  if(props.bold) classNames.push('is-bold')

  return (
    <span className={classNames.join(' ')} style={props.style}>
      {props.children}
    </span>
  )
}

const Center = props => {
  const classNames = ['Style', 'Style-Center']

  return (
    <div className={classNames.join(' ')} style={props.style}>
      {props.children}
    </div>
  )
}

const Flex = props => {
  const classNames = ['Style', 'Style-Flex']

  return (
    <div className={classNames.join(' ')} style={props.style}>
      {props.children}
    </div>
  )
}

export const Style = {
  Color,
  Center,
  Flex
}


// WEBPACK FOOTER //
// ./src/components/library/style/Style.js